export default __webpack_public_path__ + "static/media/moderate.84b4dd41.jpg";